import { Link } from 'react-router-dom';
import { MockNote } from '@/components/foundations';
import { AppShell, PageHeader, PageTitle } from '@/components/layout';
import { Icon } from '@/components/foundations';
import { Badge, DataTable, InstallmentBadge, Panel, StatCard, SummaryList, type BadgeTone } from '@/components/data';
import { Notice } from '@/components/feedback';
import { FIN_TX, MONTH, brl } from '@/mocks/financas';
import { Amount, CATEGORY_ITEMS } from './parts';
import { CategoryBars } from '@/components/charts';

/** Resumo mensal de finanças pessoais (Inter PF via Pluggy) — mock. */
export function FinResumoPage() {
  const balance = MONTH.income - MONTH.expenses;
  return (
    <AppShell>
      <main className="content">
        <PageHeader subtitle="Acompanhe suas finanças pessoais do mês." period={MONTH.label} />
        <PageTitle title="Finanças" />
        <section className="stats" aria-label="Indicadores">
          <StatCard icon="dn" label="Entradas" value={brl(MONTH.income)} trend={{ dir: 'up', value: '4,2%', text: 'vs mês anterior' }} />
          <StatCard icon="up" label="Saídas" value={brl(MONTH.expenses)} trend={{ dir: 'up', value: '8,0%', text: 'vs mês anterior' }} />
          <StatCard icon="wallet" label="Saldo do mês" value={brl(balance)} hint="entradas − saídas" />
          <StatCard icon="layers" label="Parcelas em novembro" value={brl(1034.7)} hint={<Link className="link" to="/financas/parcelas" style={{ fontSize: 13 }}>Ver parcelas <Icon name="chev" /></Link>} />
        </section>
        <section className="dash-grid">
          <Panel title="Gastos por categoria" action={<label className="dropdown sm">Outubro<Icon name="down" /></label>}>
            <CategoryBars items={CATEGORY_ITEMS} max={1800} format={brl} />
          </Panel>
          <Panel title="Resumo do período">
            <SummaryList
              items={[
                { label: 'Compras novas', value: brl(MONTH.newPurchases) },
                { label: 'Parcelas de compras antigas', value: brl(MONTH.oldInstallments) },
                { label: 'Contas fixas', value: brl(MONTH.fixed) },
              ]}
              total={{ label: 'Fatura atual', value: brl(3487.12), valueStyle: { color: 'var(--navy)' } }}
            />
            <Notice trailingIcon="trend">Restaurantes caiu 12%<br />em relação a setembro.</Notice>
          </Panel>
        </section>
        <Panel as="section" variant="recent" title="Lançamentos recentes" action={<Link to="/financas/extrato">Ver extrato completo <Icon name="chev" /></Link>}>
          <DataTable
            rows={FIN_TX.slice(0, 5)}
            rowKey={(t) => t.id}
            columns={[
              { key: 'date', header: 'Data', render: (t) => t.date },
              { key: 'desc', header: 'Descrição', cellClassName: 'wrap', render: (t) => <>{t.desc} {t.installment && <InstallmentBadge value={t.installment} />}</> },
              { key: 'cat', header: 'Categoria', hideOnMobile: true, render: (t) => <Badge tone="neutral">{t.category}</Badge> },
              { key: 'acc', header: 'Conta', hideOnMobile: true, render: (t) => t.account },
              { key: 'val', header: 'Valor', align: 'right', render: (t) => <Amount v={t.amount} /> },
              { key: 'go', header: '', align: 'right', hideOnMobile: true, render: () => <Icon name="chev" className="chev-c" /> },
            ]}
          />
        </Panel>
        <MockNote />
      </main>
    </AppShell>
  );
}
